class AwardCategories {
  constructor(element) {
    this._element = element
    this._init()
  }

  _state = {
    isVisible: false,
    scrollTop: 0
  }

  _init() {
    this._cacheSelectors()
    this._initUI()
  }

  _cacheSelectors() {
    this._closeButton = document.querySelectorAll('.award-categories .button--close')
    this._openButton = document.querySelectorAll('.open-categories')
    this._formButton = document.querySelectorAll('.award-categories .open-form')
    this._body = document.body
    this._html = document.documentElement
  }

  _initUI() {
    this._openButton.forEach(toggle =>
      toggle.addEventListener('click', () => this._handleOpen())
    )

    this._closeButton.forEach(close =>
      close.addEventListener('click', (e) => this._handleClose(e))
    )

    this._formButton.forEach(button =>
      button.addEventListener('click', () => this._handleCloseAndOpenForm())
    )
  }

  _handleClose(e) {
    e.preventDefault()
    this._element.classList.add('hidden')
    this._element.classList.remove('visible')
    this._body.setAttribute('data-modal', false)
    this._state.isVisible = false
    this._body.scrollTop = this._html.scrollTop = this._state.scrollTop
  }

  _handleOpen() {
    this._state.scrollTop = this._body.scrollTop || this._html.scrollTop
    this._body.setAttribute('data-modal', true)
    this._element.classList.remove('hidden')
    this._element.classList.add('visible')
    this._state.isVisible = true
  }

  _handleCloseAndOpenForm() {
    this._element.classList.add('hidden')
    this._element.classList.remove('visible')
    this._body.setAttribute('data-modal', false)
    this._state.isVisible = false
  }
}

export default AwardCategories
